import React from 'react';
import Loadable from 'react-loadable';

/**
 * 2019.02월 이후 react-loadable이 Webpack v4+과 Babel v7+에 더이상 호환이 되지 않으며,
 * 유지보수가 되지 않는 문제가 있다고함.
 * 그의 대안을 위한 @loadable/component로 대체예정
 * ex) import loadable from '@loadable/component';
 * export const SongsCopyRight = loadable(
      () => import('./playlist/SongsCopyRight'),
      {
        fallback: Loading,
        log: console.log('@loadable/component test'),
      },
   );
   @loadable/component를 react-router-dom 4.3.x
   이하 버전과 사용 시 React.lazy와 브라우저 콘솔에 동일한 오류 메시지가 발생하나 정상적으로 동작은 함.
   (react-router-dom 4.4+으로 설치하면 해당 에러는 발생하지 않음.)
 */
// import loadable from '@loadable/component';

export const Loading = (x, y, z) => {
  return <div></div>;
};

//* Info *//
export const Selling = Loadable({
  loader: () => import('./Selling'),
  loading: Loading,
});

export const Drmuzy = Loadable({
  loader: () => import('./Drmuzy'),
  loading: Loading,
});

//* NotFound *//
export const NotFound = Loadable({
  loader: () => import('./NotFound'),
  loading: Loading,
});

//* SellingDefault *//
export const SellingDefault = Loadable({
  loader: () => import('./selling/Selling'),
  loading: Loading,
});

//* SellingDefault *//
export const SellingMixin = Loadable({
  loader: () => import('./selling/SellingMixin'),
  loading: Loading,
});

export const V3SellingMixin = Loadable({
  loader: () => import('./v3drmuzy/SellingMixin'),
  loading: Loading,
});

export const IsDrMuzy = Loadable({
  loader: () => import('../../pages/selling/Main'),
  loading: Loading,
});

export const FreeExperience = Loadable({
  loader: () => import('../../pages/freeexperience/FreeMain'),
  loading: Loading,
});
